import { BF2CreateAsset, BF2CreateHitArea } from "../BF2BuildingGraphicsUtils";
var Container = PIXI.Container;
var Point = PIXI.Point;
var OUTSKIRT_BUILDING_SCALE = 1 / 0.666;
export var BF2GetConfigBasedOutskirtBuilding = function (config, flipped, scale) {
    if (flipped === void 0) { flipped = false; }
    if (scale === void 0) { scale = OUTSKIRT_BUILDING_SCALE; }
    var assets = config.assets.map(function (cfg) { return BF2CreateAsset(cfg, false, scale); });
    var container = new Container();
    if (assets.length > 0) {
        // @ts-ignore
        container.addChild.apply(container, assets);
        container.interactive = true;
        container.interactiveChildren = false;
        container.hitArea = BF2CreateHitArea(config.colliders, new Point(0, 0), container, flipped);
        if (flipped) {
            container.scale.x *= -1;
        }
    }
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetConfigBasedOutskirtBuilding.ts
// module id = 165
// module chunks = 3